/**
 * Derives backend origin from `VITE_API_URL`.
 *
 * @remarks
 * Admin can use either origin-only URLs (`https://api...`) or absolute paths that
 * include `/api`. This helper normalizes both forms so shared health checks can
 * construct endpoint URLs safely.
 */
export const getBackendOrigin = (): string => {
  const rawBase = import.meta.env.VITE_API_URL;
  const trimmed = rawBase.trim();

  if (!trimmed) {
    return "";
  }

  const withoutTrailingSlash = trimmed.endsWith("/")
    ? trimmed.slice(0, -1)
    : trimmed;

  if (withoutTrailingSlash.toLowerCase().endsWith("/api")) {
    return withoutTrailingSlash.slice(0, -4);
  }

  return withoutTrailingSlash;
};
